"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.initialState = void 0;
var string_1 = require("remota-client/util/string");
var util_1 = require("remota-common/util");
var action_1 = require("./action");
exports.initialState = {
    ids: [],
    messages: [],
};
function reducer(state, action) {
    var _a;
    if (state === void 0) { state = exports.initialState; }
    switch (action.type) {
        case action_1.ADD: {
            var _b = action.payload, body_1 = _b.body, now = _b.now;
            var displayMillisec = (_a = body_1.displayMillisec) !== null && _a !== void 0 ? _a : 5000;
            var displayStartAt_1 = now.getTime();
            var idx = state.messages.findIndex(function (mes) { return mes.message === body_1.message; });
            if (idx >= 0) {
                return __assign(__assign({}, state), { messages: (0, util_1.put)(state.messages, idx, __assign(__assign(__assign({}, state.messages[idx]), body_1), { displayMillisec: displayMillisec, displayStartAt: displayStartAt_1 })) });
            }
            else {
                return __assign(__assign({}, state), { messages: state.messages
                        .concat(__assign(__assign({ id: (0, string_1.random)() }, body_1), { displayMillisec: displayMillisec, displayStartAt: displayStartAt_1 }))
                        .filter(function (item) { return item.displayStartAt + item.displayMillisec > displayStartAt_1; })
                        .sort(function (a, b) { return b.displayStartAt - a.displayStartAt; }) });
            }
        }
        case action_1.DROP: {
            var nowTimestamp_1 = action.payload.now.getTime();
            return __assign(__assign({}, state), { messages: state.messages.filter(function (item) {
                    return item.id !== action.payload.id && item.displayStartAt + item.displayMillisec > nowTimestamp_1;
                }) });
        }
        default: {
            var _1 = action;
            return state;
        }
    }
}
exports.reducer = reducer;
